"use strict";
var anObject = require("../internals/an-object");
var aConstructor = require("../internals/a-constructor");
var isNullOrUndefined = require("../internals/is-null-or-undefined");
var wellKnownSymbol = require("../internals/well-known-symbol");
var SPECIES = wellKnownSymbol("species");
module.exports = function(O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === void 0 || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};
